module.exports = __webpack_public_path__ + "static/img/xianglian.d95e4be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xianglian.png
// module id = x9Qi
// module chunks = 3